import CustomSvg from "../../svgs/CustomSvg";
import { useNavigate } from "react-router-dom";
import { useSearchPlayer } from "../../../hooks/userSearchPlayer";
export default function PlayerProfile({ player, accountType }) {
  const navigate = useNavigate();
  const { playerDetails } = useSearchPlayer(player?.username);

  const handlePlayClick = () => {
    if (player) {
      // Store selected opponent details in localStorage
      localStorage.setItem(
        "selectedOpponentData",
        JSON.stringify({
          opponentId: player._id,
          opponentUsername: player.username,
          opponentAvatar: player.profile,
        })
      );

      // Navigate to top games page with opponent ID as URL param
      navigate(`/games?opponentId=${player._id}`);
    }
  };

  if (player) {
    const { profile, username, bio, numberOfWins } = player;

    //   console.log({userDetails});
    const handleChatClick = () => {
      // Navigate to chat with the selected user
      navigate("/chat", {
        state: {
          selectedUser: {
            _id: player._id,
            name: username,
            avatar: profile,
            username: username,
          },
        },
      });
    };

    return (
      <div>
        <h1 className="m-0 p-0 mb-4 font-extrabold font-quantico text-lg text-center justify-center text-white">
          <span
            className={`text-xl font-bold bg-clip-text text-transparent 
    ${
      accountType === "celebrity"
        ? "bg-gradient-to-r from-[#C6BCFF] to-[#3F9217]"
        : "bg-gradient-to-r from-[#BE3593] to-[#9FCC3B]"
    }
  `}
          >
            Profile
          </span>
        </h1>

        <div className="flex flex-col items-center mb-5">
          <div
            className={`border-2 rounded-full flex items-center justify-center p-1 ${
              accountType === "celebrity"
                ? "border-green-500"
                : " border-yellow-400"
            }`}
          >
            <img
              src={profile}
              alt={`${username}'s profile`}
              className="rounded-full w-40 h-40 object-cover"
            />
          </div>
          <div className="mx-2 mt-2">
            <h5 className="m-0 mb-1 p-0 text-white font-poppins font-semibold regular-txt">
              {username}
            </h5>
          </div>
        </div>

        <h4 className="m-0 p-0 font-poppins font-medium leading-8 text-white mb-3">
          Bio
        </h4>

        <p className="m-0 p-0 mb-4 font-poppins text-white font-light opacity-70">
          {playerDetails?.[0]?.bio || bio || "No bio available."}
        </p>

        <div className="flex items-center justify-between mb-5">
          <div>
            <h6 className="m-0 p-0 mb-3 text-white font-poppins leading-8 font-medium">
              Favorite Game
            </h6>
            <p
              className={`m-0 p-0 capitalize  text-sm font-normal font-poppins ${
                accountType === "celebrity"
                  ? "text-green-500"
                  : " text-pink-600"
              }`}
            >
              {playerDetails?.[0]?.favoriteGame?.name || "Not Game Played Yet"}
            </p>
          </div>
          <div>
            <h6 className="m-0 p-0 mb-3 text-white font-poppins leading-8 font-medium">
              Number of Wins
            </h6>
            <p
              className={`m-0 p-0 capitalize  text-sm font-normal font-poppins ${
                accountType === "celebrity" ? "text-green-500" : "text-pink-600"
              }`}
            >
              {numberOfWins} {numberOfWins === 1 ? "win" : "wins"}
            </p>
          </div>
        </div>

        <button
          onClick={handleChatClick}
          className={`w-full flex items-center justify-center p-2 mb-3 ${
            accountType === "celebrity" ? "bg-green-500" : " bg-pink-600"
          }`}
        >
          <p className="p-0 m-0 text-sm text-white font-medium font-poppins mx-1 capitalize">
            Chat {username}
          </p>
          <div className="m-0 p-0 mx-2 flex items-center">
            <CustomSvg name={"arrow-right"} />
          </div>
        </button>

        <button
          onClick={handlePlayClick}
          className={`w-full bg-transparent flex items-center justify-center border p-2 mb-3 ${
            accountType === "celebrity"
              ? "border-green-500"
              : " border-pink-600"
          }`}
        >
          <p className="p-0 m-0 text-sm text-white font-medium font-poppins mx-1 capitalize">
            Play {username}
          </p>
          <div className="m-0 p-0 mx-2 flex items-center">
            <CustomSvg name={"arrow-right"} />
          </div>
        </button>
      </div>
    );
  }
}
